/**
 * @module modules/graph-title-sk
 * @description <h2><code>graph-title-sk</code></h2>
 *
 * A Title element meant to be specifically used for individual Graphs. A map of title entries
 * can be provided through the set function. The key value pairs are displayed in two separate
 * rows.
 *
 * @example
 *
 * Input:
 * {
 *  "bot": "linux-perf",
 *  "benchmark": "Speedometer2",
 *  "test": "",
 *  "subtest_1": "100_objects_allocated_at_initialization"
 * }
 *
 * Output raw title:
 * bot          benchmark     subtest_1
 * linux-perf   Speedometer2  100_objects_allocated_at_...
 *
 * "test" is ignored as its value is empty, and "subtest_1"'s value is truncated.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GraphTitleSk", {
    enumerable: true,
    get: function() {
        return GraphTitleSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const MAX_PARAMS = 8;
let GraphTitleSk = class GraphTitleSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    /**
   * Public function to set title entries and render.
   */ set(titleEntries, numTraces, rawTitleEntries = null) {
        this.titleEntries = titleEntries;
        this.numTraces = numTraces;
        this.rawTitleEntries = rawTitleEntries;
    }
    showRaw() {
        this.showRawTitle = true;
    }
    /**
   * Generates the HTML for this.titleEntries (or rawTitleEntries). Empty keys or values
   * will result in the entry being ignored. Values longer than
   * 25 characters are truncated to avoid crowding.
   *
   * @returns - a list of HTML-formatted titleEntries.
   */ getTitleHtml() {
        const activeEntries = this.showRawTitle && this.rawTitleEntries ? this.rawTitleEntries : this.titleEntries;
        if (activeEntries === null || this.numTraces === 0) {
            return [];
        }
        if (activeEntries.size === 0 && this.numTraces > 0) {
            return [
                (0, _lit.html)`<h1>Multi-trace Graph (${this.numTraces} traces)</h1>`
            ];
        }
        const elems = [];
        const showShort = this.showShortTitle && activeEntries.size > MAX_PARAMS;
        let index = 0;
        activeEntries.forEach((value, key)=>{
            if (showShort && index >= MAX_PARAMS) {
                return;
            }
            index++;
            if (value !== '' && key !== '') {
                const elem = (0, _lit.html)`
          <div class="column">
            <div class="param">${key}</div>
            <div class="hover-to-show-text" title=${value}>${value}</div>
          </div>
        `;
                elems.push(elem);
            }
        });
        if (showShort) {
            const elem = (0, _lit.html)`
        <md-text-button
          class="showMore"
          @click=${(e)=>{
                e.stopPropagation();
                this.showFullTitle();
            }}>
          Show Full Title
        </md-text-button>
      `;
            elems.push(elem);
        }
        return elems;
    }
    showFullTitle() {
        this.showShortTitle = false;
    }
    showShortTitles() {
        this.showShortTitle = true;
    }
    render() {
        const canToggle = this.rawTitleEntries !== null && this.rawTitleEntries !== this.titleEntries && !this.showRawTitle;
        return (0, _lit.html)`
      <div
        id="container"
        ?hidden=${this.numTraces === 0}
        @click=${canToggle ? this.showRaw : undefined}
        style=${canToggle ? 'cursor: pointer;' : ''}>
        ${this.getTitleHtml()}
      </div>
    `;
    }
    constructor(...args){
        super(...args);
        this.titleEntries = null;
        this.rawTitleEntries = null;
        this.numTraces = 0;
        this.showShortTitle = true;
        this.showRawTitle = false;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Object)
], GraphTitleSk.prototype, "titleEntries", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Object)
], GraphTitleSk.prototype, "rawTitleEntries", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number
    }),
    _ts_metadata("design:type", Number)
], GraphTitleSk.prototype, "numTraces", void 0);
_ts_decorate([
    (0, _decorators.state)()
], GraphTitleSk.prototype, "showShortTitle", void 0);
_ts_decorate([
    (0, _decorators.state)()
], GraphTitleSk.prototype, "showRawTitle", void 0);
GraphTitleSk = _ts_decorate([
    (0, _decorators.customElement)('graph-title-sk')
], GraphTitleSk);
